import { RcFile } from 'antd/lib/upload';
import { call, put } from 'redux-saga/effects';
import { CreditLimitsService } from '../../../services/CreditLimits';
import { CustomersService } from '../../../services/Customers';
import { setCreditRenewCode } from '../customers/actions';
import { ECreditRenewStatus, ICustomer } from '../customers/types';
import {
  loadCreditLimitsSuccess,
  loadCreditLimitsFailure,
  requestRenewCreditLimitsSuccess,
  requestRenewCreditLimitsFailure
} from './actions';
import { ICreditLimits, Types } from './types';

interface ILoadCreditLimitsParams {
  payload: {
    selectedCustomerId: string;
  };
  type: Types;
}

interface IRenewCreditLlimitParams {
  payload: {
    customer: ICustomer;
    renewCreditValue: number;
    files: RcFile[];
  };
  type: Types;
}

export function* loadCreditLimitsSaga(params: ILoadCreditLimitsParams) {
  const { selectedCustomerId } = params.payload;
  try {
    const creditLimitsService = new CreditLimitsService();
    const creditLimits: ICreditLimits = yield call(
      creditLimitsService.getCreditLimits.bind(creditLimitsService),
      selectedCustomerId
    );
    yield put(loadCreditLimitsSuccess(creditLimits));
  } catch (err) {
    console.error('loadCreditLimits', err);
    yield put(loadCreditLimitsFailure(err));
  }
}

export function* requestRenewCreditSaga(params: IRenewCreditLlimitParams) {
  const { customer, renewCreditValue, files } = params.payload;
  try {
    const creditLimitsService = new CreditLimitsService();
    const creditRenewData: {
      creditRenewCode: string;
      creditRenewRequestId: string;
    } = yield call(
      creditLimitsService.requestRenewCreditLimits.bind(creditLimitsService),
      customer.customerId,
      renewCreditValue,
      files
    );

    let { creditRenewCode, creditRenewRequestId } = creditRenewData;
    let creditRenewRequestStatus = ECreditRenewStatus.IN_PROCESS;
    let alreadyRequested = false;

    if (!creditRenewCode) {
      // se não tiver o code e não der erro, significa que o chamado já está registrado. Então precisa atualizar o Customer
      const customersService = new CustomersService();
      const updatedCustomer: ICustomer = yield customersService.getCustomerById(
        customer.customerId
      );
      alreadyRequested = true;
      creditRenewCode = updatedCustomer.creditRenewCode || '';
      creditRenewRequestId = updatedCustomer.creditRenewRequestId || '';
      creditRenewRequestStatus =
        updatedCustomer.creditRenewRequestStatus as ECreditRenewStatus;
    } else if (files.length > 0) {
      // se tiver o code e o valor do limite for > 250k, significa que o chamado foi registrado e agora precisa passar os documentos.
      yield creditLimitsService.uploadCreditLimitDocs(
        customer.customerId,
        files
      );
    }

    yield put(
      setCreditRenewCode(
        customer.customerId,
        creditRenewCode,
        creditRenewRequestId,
        creditRenewRequestStatus
      )
    ); // atualiza o campo creditRenew e creditRenewCode para não mostrar mais o botão de renovação
    yield put(requestRenewCreditLimitsSuccess(alreadyRequested));
  } catch (err) {
    console.error('loadCreditLimits', err);

    yield put(requestRenewCreditLimitsFailure(err));
  }
}
